module.exports = __webpack_public_path__ + "img/1533032015.4608ae1e.jpg";